const truncate = (text: string, limit: number = 17) : string => {
    if (text.length > limit) {
        return text.substring(0, limit) + '…'
     }
     return text
}

export default truncate